import React from 'react';

import { Navigate } from 'react-router-dom';

const RequireAuth = ({ children, authed }) => {

    return authed ? children :  <Navigate to="/auth/"/>;
};

export default RequireAuth;